import axios from 'axios';
// import { log } from 'util';
import types from '../actionTypes';
import { apiEndpoint, apiUrl } from '../../settings';
import { toast } from 'react-toastify';

/* TASKLIST */
export const setTestName = (name) => ({ type: types.SET_TEST_NAME, name });
export const changeActiveTask = (groupModule, taskID) => ({
	type: types.SET_EDITOR_ACTIVE_TASK,
	groupModule,
	taskID,
});
export const addTask = (task, index) => {
	return (dispatch) => {
		dispatch({ type: types.ADD_EDITOR_TASK, task, index });
	};
};
export const deleteTask = (taskID) => ({ type: types.DELETE_EDITOR_TASK, taskID });
export const moveTask = (tasks) => ({ type: types.MOVE_EDITOR_TASK, tasks });
export const setTasks = (groupID, tasks) => ({ type: types.SET_EDITOR_TASKS, groupID, tasks }); //add, remove and change task position in editor
export const setEditorPDF = (testPDF, keyPDF) => ({
	type: types.SET_EDITOR_PDF,
	testPDF,
	keyPDF,
});

export const getPDF = (test, userID, groups, fileType, callback = () => {}) => {
	if (!test.tasks.length > 0 || !userID || !groups) return;
	const openPDF = (pdf) => {
		const link = document.createElement('a');
		link.href = `${apiUrl}/pdf_output/${pdf}`;
		link.target = '_blank';
		document.body.appendChild(link);
		link.click();
		link.remove();
	}

	return dispatch => {
		if(test[`${fileType}PDF`]){
			openPDF(test[`${fileType}PDF`]);
			callback();
		}else {
			dispatch(generatePDF(test, userID, groups, (data) => {
				openPDF(data[`${fileType}PDF`]);
				callback();
			}))
		}
	}
	
	
}

export const generatePDF = (test, userID, groups, callback = () =>{}) => {
	let dataFormData = new FormData();
	dataFormData.append('funkcja', 'wygeneruj_test_pdf');
	dataFormData.append('id_uzytkownika', userID);
	dataFormData.append(
		'lista_pytan',
		test.tasks.map((task) => Number(task['id_pytania']))
	);
	dataFormData.append('liczba_grup', groups);
	dataFormData.append('identyfikator_testu', test.nazwa);
	dataFormData.append('print_mode', 'print_digital');

	return (dispatch) => {
		axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		})
			.then((res) => {
				if (res.data.success) {
					dispatch(setEditorPDF(res.data.pdf, res.data['pdf_klucz']));
					callback({testPDF: res.data.pdf, keyPDF: res.data['pdf_klucz']});
				} else {
					toast.error('Nie udało się pobrać testu', {
						closeButton: false,
						autoClose: 2500,
						hideProgressBar: true,
					});
					dispatch({ type: types.CLOSE_MODAL });
					throw Error(res.data);
				}
			})
			.catch((err) => console.log(err));
	};
};
export const resetEditor = () => ({ type: types.RESET_EDITOR });

export const setEditorMode = (payload) => ({ type: types.SET_EDITOR_MODE, payload });
